export const environment = {
  production: true,
  apiUrl: "https://api.youprice.fr/Vitrine",
  apiUrlLocal: "http://localhost:9079/Vitrine",
  SG_PAYEMENT_PUBLIC_KEY: "52251231:publickey_RdpaAXYQ3GhZ3QWU9VNTpZVwHq9JOV2SSqvssD5Jny8Zm",
  SG_PAYEMENT_URL: "https://api-sogecommerce.societegenerale.eu/",
  simPrice:5
};